const CustomerRatingButton = () => null;

export default CustomerRatingButton;
